/**
 * Theme Toggle Component
 * Allows users to switch between light and dark themes
 */

import { Moon, Sun } from 'lucide-react';
import { useTheme } from '../stores/themeStore';

export const ThemeToggle: React.FC = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      className="flex items-center justify-between w-full p-4 lg:p-6 bg-kind-container rounded-xl border border-gray-300 dark:border-white/10 hover:bg-kind-graphite dark:hover:bg-kind-graphite transition-colors"
      aria-label="Toggle theme"
    >
      <div className="flex items-center space-x-3">
        {theme === 'light' ? (
          <Sun className="h-5 w-5 text-kind-text-secondary" />
        ) : (
          <Moon className="h-5 w-5 text-kind-text-secondary" />
        )}
        <div className="text-left">
          <h3 className="text-base lg:text-lg font-medium text-kind-text-primary">Theme</h3>
          <p className="text-sm text-kind-text-secondary">
            {theme === 'light' ? 'Light mode' : 'Dark mode'}
          </p>
        </div>
      </div>

      <div className="relative inline-block w-12 h-6">
        <div
          className={`absolute inset-0 rounded-full transition-colors duration-200 ${
            theme === 'dark' ? 'bg-kind-purple' : 'bg-gray-300'
          }`}
        />
        <div
          className={`absolute top-0.5 left-0.5 w-5 h-5 bg-white rounded-full shadow-md transition-transform duration-200 ${
            theme === 'dark' ? 'transform translate-x-6' : ''
          }`}
        />
      </div>
    </button>
  );
};
